var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.movies)?_c('MovieList',{attrs:{"movies":_vm.movies}}):_vm._e(),(_vm.popupDorms && _vm.popupDorms.length > 0)?_c('FixedPopup',{attrs:{"dorms":_vm.popupDorms}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }